<template>
  <label for="table-search" class="sr-only"> Buscar </label>

  <!-- campo de busca -->
  <div class="relative">
    <div
      class="absolute inset-y-0 rtl:inset-r-0 start-0 flex items-center ps-3 pointer-events-none"
    >
      <component :is="PhMagnifyingGlass" class="w-4 h-4 text-gray-500" />
    </div>

    <input
      type="text"
      id="table-search-users"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      class="block p-2 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg w-80 bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
      placeholder="Buscar"
    />
  </div>
</template>

<script setup>
import { PhMagnifyingGlass } from '@phosphor-icons/vue'

defineProps({
  modelValue: String
})

</script>
